<script setup>
import IconBase from '@/components/icon/IconBase.vue'
import { mediaTypeMeta } from './mediaflowMeta'

/** Source / graphic type: one tight row of small icon cards with one-line labels. */
defineProps({
	/** [{ value, hint? }] */
	options: { type: Array, required: true },
	modelValue: { type: String, default: '' },
	label: { type: String, default: 'Type' },
	disabled: { type: Boolean, default: false },
})
const emit = defineEmits(['select'])
</script>

<template>
	<div>
		<span class="mb-1.5 block text-tiny font-medium text-surface-text-1">{{ label }}</span>
		<div class="grid gap-1.5" :style="{ gridTemplateColumns: `repeat(${options.length}, minmax(0, 1fr))` }" role="radiogroup" :aria-label="label">
			<button
				v-for="option in options"
				:key="option.value"
				type="button"
				role="radio"
				:aria-checked="modelValue === option.value"
				:aria-label="mediaTypeMeta(option.value).label"
				:title="option.hint || mediaTypeMeta(option.value).label"
				:disabled="disabled"
				class="flex min-w-0 flex-col items-center gap-1 rounded-lg px-1 py-2 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-main disabled:cursor-not-allowed disabled:opacity-60"
				:class="modelValue === option.value ? 'bg-main-transparent ring-1 ring-main' : 'bg-surface-3 hover:bg-surface-4'"
				:data-testid="`type-${option.value}`"
				@click="emit('select', option)"
			>
				<span class="flex size-6 items-center justify-center rounded-md" :class="mediaTypeMeta(option.value).tone">
					<icon-base width="14" height="14" :width-view-box="mediaTypeMeta(option.value).viewBox" :height-view-box="mediaTypeMeta(option.value).viewBox" :fill="mediaTypeMeta(option.value).fill">
						<component :is="mediaTypeMeta(option.value).icon" />
					</icon-base>
				</span>
				<span class="block w-full truncate text-center text-[0.7rem] font-medium leading-tight text-surface-text-2">{{ mediaTypeMeta(option.value).label }}</span>
			</button>
		</div>
	</div>
</template>
